import React, { useEffect, useRef, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import ExpertiseDropDown from "./DropDowns/ExpertiseDropDown";
import LevelsDropDown from "./DropDowns/LevelsDropDown";
import HowHelpDropDown from "./DropDowns/HowHelpDropDown";

export default function Experience({ initial, uploadMedia, saveProfile, onNext, onBack }) {
  const fileInput = useRef();
  const [form, setForm] = useState({
    expertise: [],
    howHelp: [],
    levels: [],
    linkedinUrl: "",
    portfolioUrl: "",
    files: [],
  });
  const [loading, setLoading] = useState(false);
  const [drag, setDrag] = useState(false);

  console.log('howHelp', form.howHelp);

  // ⬇️ sync with `initial`
  useEffect(() => {
    if (!initial) return;
    setForm((p) => ({
      ...p,
      expertise: initial.expertise ?? [],
      howHelp: initial.howHelp ?? [],
      levels: initial.levels ?? [],
      linkedinUrl: initial.linkedinUrl ?? "",
      portfolioUrl: initial.portfolioUrl ?? "",
      // keep local `files` as-is; they are client-only
    }));
  }, [initial]);

  const setArr = (k) => (val) => setForm((p) => ({ ...p, [k]: val }));
  const text = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const add = (fList) => setForm((p) => ({ ...p, files: [...p.files, ...fList] }));
  const onDrop = (e) => { e.preventDefault(); setDrag(false); add(Array.from(e.dataTransfer.files)); };

  const submit = async (e) => {
    e.preventDefault();
    let resume = "";
    const pdf = form.files.find((f) => f.type === "application/pdf");
    if (pdf) resume = await uploadMedia([pdf], setLoading);

    await saveProfile({
      experience: {
        expertise: form.expertise,
        levels: form.levels,
        linkedinUrl: form.linkedinUrl,
        portfolioUrl: form.portfolioUrl,
        howHelp: form.howHelp,
        resume,
      },
    });
    onNext();
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <div className={Classes.infoConMiddle}>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Areas of Expertise</h5>
              <ExpertiseDropDown selected={form.expertise} onChange={setArr("expertise")} />
            </div>
          </div>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>How Do You Want to Help Mentees</h5>
              <HowHelpDropDown selected={form.howHelp} onChange={setArr("howHelp")} />
            </div>
          </div>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Level of Experience</h5>
              <LevelsDropDown selected={form.levels} onChange={setArr("levels")} />
            </div>
          </div>

          {[
            ["linkedinUrl", "LinkedIn Profile URL", "https://linkedin.com/in/you"],
            ["portfolioUrl", "Portfolio URL", "https://portfolio.example.com"],
          ].map(([k, l, ph]) => (
            <div key={k} className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <div className="flexAlign10">
                  <h5 className={Classes.label}>
                    {l}
                  </h5>
                  <div className="optionalText"><h5>Optional</h5></div>
                </div>
                <input
                  name={k}
                  className={Classes.inputField}
                  placeholder={ph}
                  value={form[k] ?? ""}
                  onChange={text}
                />
              </div>
            </div>
          ))}

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>Resume</h5>
                <div className="optionalText"><h5>Optional</h5></div>
              </div>
              <div
                className={`${Classes.fileUpload} ${drag ? Classes.dragActive : ""}`}
                onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
                onDragLeave={() => setDrag(false)}
                onDrop={onDrop}
                onClick={() => fileInput.current.click()}
              >
                <input
                  ref={fileInput}
                  type="file"
                  className={Classes.fileInput}
                  onChange={(e) => add(Array.from(e.target.files))}
                />
                <h5><span className={Classes.browseText}>Browse</span> or drag & drop</h5>
              </div>
              {form.files.length > 0 && (
                <ul className={Classes.fileList}>
                  {form.files.map((f, i) => (
                    <li key={i}><h5>{f.name}</h5></li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
      </form>
    </>
  );
}
